import { memo, useState } from 'react'
import styled from 'styled-components'
import { Avatar } from '@/components/avatar'
import { colors } from '@/styles'
import { show as showProfilePictureModal } from '@/features/Chat/profile-picture-modal'
import TimeStamp from './timestamp'
import { TLD1 } from './tld'
import ChatEvent from '../chat-event'

const MessageBubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  ${props =>
    props.isDrawerMessage &&
    `
    max-width: 100%;
  `}
  align-self: ${props => (props.isThem ? ' flex-start' : 'flex-end')};
  align-items: ${props => (props.isThem ? 'flex-start' : 'flex-end')};
  position: relative;
  ${props =>
    !props.isSupportRoom &&
    props.pointer &&
    !props.isThem &&
    `
    cursor: pointer;
  `}
  ${props =>
    props.groupChatNotLastMessage &&
    props.isThem &&
    `
    margin-left: 32px;
  `}
${props =>
    !props.isGroupChat &&
    props.isThem &&
    `
  margin-left: 0px;
`}
`

const AvatarWrapper = styled.div`
  cursor: pointer;
`

const EventContainer = styled.div`
  display: flex;
  align-items: flex-end;
  ${props =>
    !props.hasAvatar &&
    `
    flex-direction: column;
    align-items: flex-start;
  `}
`

const AvatarPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  border-radius: 50%;
  margin-right: 8px;
  width: 24px;
  height: 24px;
  color: ${colors.white};
  background-color: ${props => (props.colour ? props.colour : colors.black)};
`

const BubbleMessage = ({
  avatar,
  event,
  isThem,
  showName,
  previousMessage,
  isGroupChat = false,
  isSupportRoom = false,
  nextMessage,
  pointer,
  isRead,
  showDrawer,
  isDrawerMessage = false,
  showUserName,
  isLastMessageOfUser,
  userData,
  colour
}) => {
  const [translatedText, setTranslatedText] = useState()

  const showChatName = showName && isThem && event?.display_name
  const pattern = new RegExp(
    `(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\\.(?:${TLD1.join(
      '|'
    )})\\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)`,
    'ig'
  )
  const hasLinks = event?.event_info?.message?.match(pattern)?.length > 0
  const hasPointer = pointer ? pointer : !hasLinks
  const avatarPlaceHolderTextArray = event?.display_name?.split(/\s+/)
  const avatarPlaceHolderText = `${avatarPlaceHolderTextArray?.[0]?.[0]}${avatarPlaceHolderTextArray?.[1]}`
  const groupChatNotLastMessage = !isGroupChat || (isGroupChat && !isLastMessageOfUser)

  return (
    <MessageBubbleContainer
      isSupportRoom={isSupportRoom}
      isDrawerMessage={isDrawerMessage}
      isThem={isThem}
      pointer={hasPointer}
      isGroupChat={isGroupChat}
      groupChatNotLastMessage={groupChatNotLastMessage}
    >
      <EventContainer hasAvatar={isGroupChat}>
        {isGroupChat &&
          isThem &&
          isLastMessageOfUser &&
          (avatar ? (
            <AvatarWrapper onClick={() => showProfilePictureModal({ userData })}>
              <Avatar location={avatar} width={24} height={24} right={8} />
            </AvatarWrapper>
          ) : (
            <AvatarWrapper onClick={() => showProfilePictureModal({ userData })}>
              <AvatarPlaceholder colour={colour}>{avatarPlaceHolderText}</AvatarPlaceholder>
            </AvatarWrapper>
          ))}
        <ChatEvent
          translatedText={translatedText}
          linkPattern={pattern}
          isThem={isThem}
          event={event}
          showChatName={showChatName}
          showUserName={showUserName}
          previousMessage={previousMessage}
          nextMessage={nextMessage}
          showDrawer={hasLinks ? () => {} : showDrawer}
          isDrawerMessage={isDrawerMessage}
          colour={colour}
        />
      </EventContainer>
      <TimeStamp
        showIcons
        showTime={true}
        translatedText={translatedText}
        setTranslatedText={setTranslatedText}
        groupChatNotLastMessage={groupChatNotLastMessage}
        isThem={isThem}
        event={event}
        isRead={isRead}
        showDrawer={showDrawer}
      />
    </MessageBubbleContainer>
  )
}

export default memo(BubbleMessage)
